import React from "react";

import "./styles.css";

const Tbody = (props) => {
  return <tbody className="t-body">{props.children}</tbody>;
};

export default Tbody;
